import React, { useContext, useEffect, useState } from "react";
//imports ARSIT
import AlertaContext from "context/alertas/alertaContext";
import UsuarioContext from "context/usuario/usuarioContext";
import AuthContext from "context/autentication/authContext";
import MensajeAlerta from "components/MensajeAlerta";
import InputMask from "react-input-mask";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClienteContext from "context/cliente/clienteContext";
import {MdVisibility, MdVisibilityOff} from "react-icons/md";
import ValidationsContext from "context/validations/validationsContext";
import {Button, TextField, Select, FormControl, MenuItem, Grid} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import { Role } from "types/roles";
import BotonLoading from "components/Buttons/BotonLoading"
/////////Estilos////////
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
      '& > * + *': {
        marginLeft: theme.spacing(2),
    },
    '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 200,
    },
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(0),
        textAlign: "center",
        color: theme.palette.text.secondary,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    margin: {
        color: "#96FCB3",
        zIndex: 999,
        margin: theme.spacing(1),
        position: "sticky",
        bottom: theme.spacing(1),
        left: "99%",
    },
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 400,
        minHeight: "65vh",
    },
}));

export default function FormNuevoUsuario(props) {
    const classes = useStyles();
    const authContext = useContext(AuthContext);
    const { rol, usuario, cliente } = authContext;
    const validationsContext = useContext(ValidationsContext);
    const { validateForm, validateUsername, validateeMail, validatePassword, validateCodigoArea, validateNumeroTelefono } = validationsContext;
    const clienteContext = useContext(ClienteContext);
    const { clientes, obtenerClientes, obtenerRoles, roles } = clienteContext;
    const [listInt, setListInt]= useState([])
    // extraer los valores del context
    const alertaContext = useContext(AlertaContext);
    const { alerta } = alertaContext;
    const usuarioContext = useContext(UsuarioContext);
    const {agregarUsuario, errorUsuario} = usuarioContext;
    const [newRol, setNewRol] = useState("");
    const clienteActual = () =>{
       /* TODO muchos clientes  return usuario.clienteRol.filter(c=>c.default)[0] */
       return usuario.cliente
    }
    const [user, guardarUsuario] = useState({
        estado: true,
        email: "",
        password: "",
        nombre: "",
        codigoPais: "+549",
        codigoArea: "",
        numeroTelefono: "",
        clienteRol: [{
        cliente: {
            id: clienteActual().id,
            razonSocial: clienteActual().razonSocial,
        }, 
        rol: newRol, 
        rolId: "",
        default: true
        }], 
        showPassword: false,
    });
    const cargarListInt = () =>{
        let data=[]
        clientes.map(c=>{data.push(c)})
        data.push(opcion)
        setListInt(data) 
    }
    const handleClickShowPassword = () => {
        guardarUsuario({ ...user, showPassword: !user.showPassword });
    };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const [errors, setErrors] = useState({
        email: "",
        password: "",
        nombre: "",
        codigoArea: "",
        numeroTelefono: "",
    })
    useEffect(() => {
        /* TODO muchos clientes if (usuario.clienteRol[0].rol !== Role.Admin) { */
        obtenerRoles()
        if (usuario.rol.nombre !== Role.Admin) {
            obtenerClientes(cliente)
            cargarListInt()
        } 
    }, []);
    const onChange = (e) => {
        guardarUsuario({
            ...user,
            [e.target.name]: e.target.value,
        });
        switch (e.target.name) {
            case 'nombre':
                setErrors({
                ...errors, nombre: validateUsername(e.target.value)
                });
                break;
            case 'email':
                setErrors({
                ...errors, email: validateeMail(e.target.value)
                });
                break;
            case 'password':
                setErrors({
                ...errors, password: validatePassword(e.target.value)
                });
                break;
            default:
                break;
        }
    };
    const controlCliente = () => {
/* TODO muchos Clientes        if (usuario.clienteRol[0].rol === Role.Integrador && (user.clienteRol[0].rol === Role.Integrador)) {*/
    if (usuario.newRol === Role.Integrador && (user.newRol === Role.Integrador)) {
        let clienteElegido = clientes.find((cl) => cl.razonSocial === opcion.razonSocial)
        user.clienteRol[0].cliente.razonSocial = opcion.razonSocial
            //user.clienteRol[0].cliente.id = clienteElegido.id
        } 
    }
    
    const onSubmit = (e) => {
        // Validar que no haya campos vacios
        if (!validateForm(errors) || user.nombre.trim() === "" ||
            user.email.trim() === "" ||
            user.password.trim() === "" ||
            user.clienteRol[0].rol.trim() === "" ||
            user.numeroTelefono.trim() === "" ||
            user.codigoArea.trim() === "") {
                errorUsuario("Todos los campos con * son obligatorios", "error");
                return;
        } else {
            controlCliente();
            // Pasarlo al action
            agregarUsuario({
                email: user.email,
                password: user.password,
                nombre: user.nombre,
                codigoPais: user.codigoPais,
                codigoArea: user.codigoArea.slice(1, 5),
                numeroTelefono: user.numeroTelefono.slice(2, 10),
                clienteId:user.clienteRol[0].cliente.id,
                rolId: user.clienteRol[0].rolId

            });
            ///refresco la tabladataUs = await clienteAxios.get('/usuarios');
            /* props.refreshUs() */
            }
        };
    const seteador = async (x, e) => {
        if (x) {
            user.clienteRol[0].rolId= roles.find( rol => rol.nombre===x).id
            user.clienteRol[0].rol = x 
        }
    }
    const setClientes = async (x, e) => {
        if (x) {
            let clienteElegido = clientes.find((cl) => cl.razonSocial === x)
            user.clienteRol[0].cliente.razonSocial = x
            user.clienteRol[0].cliente.id = (x!==opcion.razonSocial) ? clienteElegido.id : opcion.id 
        }
    }
    const clienteId = cliente;
    const opcion = clienteActual();

    const [disabled, setDisabled] = useState(true)
    return(
    <div className={classes.form} style={{marginTop:"0px"}} noValidate onSubmit={onSubmit} autocomplete="off">
        <Grid container spacing={1} display="row" justify="center" alignItems="center">
            <Grid item xs={10} md={10} lg={10}>
                <TextField
                autocomplete="nope"
                error={errors.nombre.length > 0}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="nombre"
                fullWidth
                name="nombre"
                label={errors.nombre.length > 0 ? errors.nombre : "Nombre"}
                value={user.nombre}
                onChange={onChange}
                />
            </Grid>
            <Grid container spacing={1}  display="row" justify="center" alignItems="center">
                <Grid item xs={10} md={5} lg={5}>
                <TextField
                    error={errors.email.length > 0}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label={errors.email.length > 0 ? errors.email : "Email"}
                    name="email"
                    value={user.email}
                    onChange={onChange}
                />
                </Grid>
                <Grid item xs={10} md={5} lg={5}>
                <FormControl
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                >
                {errors.password.length > 0 ?
                    <InputLabel htmlFor="outlined-adornment-password" style={{ color: "red" }} >
                    {errors.password.length > 0 ? errors.password : "Contraseña"}
                    </InputLabel> :
                    <InputLabel htmlFor="outlined-adornment-password" >
                        Contraseña
                </InputLabel>}
                <OutlinedInput
                    error={errors.password.length > 0}
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    label={errors.password.length > 0 ? errors.password : "Contraseña"}
                    name="password"
                    id="outlined-adornment-password"
                    type={user.showPassword ? "text" : "password"}
                    value={user.password}
                    onChange={onChange}
                    endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                        {user.showPassword ? (
                            <MdVisibility />
                        ) : (
                            <MdVisibilityOff />
                        )}
                        </IconButton>
                    </InputAdornment>
                    }
                />
                </FormControl>
            </Grid>
            </Grid>
            <Grid container spacing={1}  display="row" justify="center" alignItems="center">
                <Grid item xs={10} md={5} lg={5}>
                    <FormControl variant="outlined" fullWidth margin="normal">
                    {rol === Role.Super ?
                        <>
                        <InputLabel id="rol-label">
                            Elegir Rol
                        </InputLabel>
                        <Select
                            labelId="newRol"
                            id="newRol"
                            name="newRol"
                            value={user.clienteRol[0].rol}
                            onChange={onChange}
                            label="Elegir Rol"
                        >
                            <MenuItem value={Role.Integrador} onClick={(e) => seteador(Role.Integrador, e)}>INTEGRADOR</MenuItem >
                            <MenuItem value={Role.Supervisor} onClick={(e) => seteador(Role.Supervisor, e)}>SUPERVISOR</MenuItem >
                        </Select>
                        </> : null}
                    {rol === Role.Admin || rol===Role.Soporte ?
                        <>
                        <InputLabel id="rol-label">
                            Elegir Rol
                </InputLabel>
                        <Select
                            labelId="newRol"
                            id="newRol"
                            name="newRol"
                            value={user.clienteRol[0].rol}
                            onChange={onChange}
                            label="Elegir Rol"
                        >
                            <MenuItem value={Role.Admin} onClick={(e) => seteador(Role.Admin, e)}>ADMIN</MenuItem >
                           {/*  <MenuItem value={Role.Operador} onClick={(e) => seteador(Role.Operador, e)}>OPERADOR</MenuItem > */}
                        </Select>
                        </> : null}
                    {rol === Role.Integrador ?
                        <>
                        <InputLabel id="rol-label">
                            Elegir Rol
                    </InputLabel>
                        <Select
                            labelId="newRol"
                            id="newRol"
                            name="newRol"
                            value={user.clienteRol[0].rol}
                            onChange={onChange}
                            label="Elegir Rol"
                        >
                            <MenuItem value={Role.Integrador} onClick={(e) => seteador(Role.Integrador, e)}>INTEGRADOR</MenuItem >
                            <MenuItem value={Role.Admin} onClick={(e) => seteador(Role.Admin, e)}>ADMIN</MenuItem >
                        </Select>
                        </> : null}
                    </FormControl>
                </Grid>
                <Grid item xs={10} md={5} lg={5}>
                    <FormControl variant="outlined" fullWidth margin="normal">
                    {(rol === Role.Super) ?
                        <>
                        <InputLabel id="listClientes-label">
                            Elegir Cliente
                        </InputLabel>
                        <Select
                            labelId="listaC"
                            id="listaC"
                            name="listaC"
                            value={user.clienteRol[0].cliente.razonSocial}
                            defaultValue={(e) => setClientes(usuario.cliente.razonSocial, e)}
                            onChange={onChange}
                            label="Elegir Cliente"
                        >
                            {clientes.length === 0 ? (
                                <MenuItem value="" >No hay clientes</MenuItem>
                            ) : (
                                clientes.map((cli) => (
                                <MenuItem key={cli.id} value={cli.razonSocial} onClick={(e) => setClientes(cli.razonSocial, e)}>
                                    {cli.razonSocial}
                                </MenuItem>
                            ))
                            )}
                        </Select>
                        </>
                        :
                        (rol === Role.Integrador) ?
                        ((user.clienteRol[0].rol === Role.Admin) ? 
                            <>
                            <InputLabel id="listClientes-label">
                                Elegir Cliente
                            </InputLabel>
                            <Select
                                labelId="listaC"
                                id="listaC"
                                name="listaC"
                                value={user.clienteRol[0].cliente.razonSocial}
                                defaultValue={(e) => setClientes(usuario.cliente.razonSocial, e)} 
                                onChange={onChange}
                                label="Elegir Cliente">
                                {listInt.length === 0 ? (
                                    <MenuItem value="" >No hay clientes</MenuItem>
                                ) : (
                                    listInt.map((cli, index) => (
                                    <MenuItem key={index} value={cli.razonSocial} onClick={(e) => setClientes(cli.razonSocial, e)}>
                                        {cli.razonSocial}
                                    </MenuItem>
                                ))
                                )}
                            </Select>
                            </>
                            :
                            <TextField
                                disabled
                                id="listaC"
                                label="Cliente"
                                //value={(e) => setClientes(opcion,e)}
                                defaultValue={opcion.razonSocial}
                                variant="outlined"
                            />)
                        :
                        <TextField
                            disabled
                            id="listaC"
                            label="Cliente"
                            /* value={(e) => setClientes(opcion,e)} */
                            defaultValue={opcion.razonSocial}
                            variant="outlined"
                        />
                    }
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={1}  display="row" justify="center" alignItems="center">
                <Grid item xs={5} md={2} lg={2}>
                    <TextField 
                        required 
                        fullWidth 
                        margin="normal" 
                        id="standard-required" 
                        label="Cod. País" 
                        defaultValue="+549" 
                        variant="outlined"
                        helperText=" " 
                        InputProps={{
                            readOnly: true,
                        }} />
                </Grid>
                <Grid item xs={5} md={3} lg={3}>
                    <InputMask
                        maskChar= ""
                        mask="\09999"
                        value={user.codigoArea}
                        onChange={onChange}
                    >
                {() => (
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="codigoArea"
                        label={"Código Área"}
                        id="codigoArea"
                        type="text"
                        helperText=" "
                    />
                )}
                </InputMask>
            </Grid>
                <Grid item xs={10} md={5} lg={5}>
                <InputMask
                    maskChar= ""
                    mask="1\599999999"
                    value={user.numeroTelefono}
                    onChange={onChange}
                >
                {() => (
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="numeroTelefono"
                        label={"Número de Teléfono"}
                        id="numeroTelefono"
                        type="text"
                        helperText="Aseguresé de ingresarlo correctamente, caso contario no podra recibir alertas via SMS"
                    />
                )}
                </InputMask>
            </Grid>
            </Grid>
            <Grid container  display="row" justify="center" alignItems="center">
                <Grid item xs={12} md={12} lg={12}>
                    <div className={classes.paper}>
                    {alerta ? (
                        alerta.categoria === "error" ? (
                        <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg} />
                        ) : <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg} close={props.handleClose} />) : null}
                    </div>
                </Grid>
                <Grid item xs={6} justify="center">
                    <DialogActions >
                        <BotonLoading texto={"Guardar"} disabled={false} load={alerta} onClick={onSubmit} user={user}/>
                    </DialogActions>
            </Grid>
            </Grid>
    </Grid>
    </div>
    );
}